import { LOCALES } from "~/const";

export const useGlobalStore = defineStore("globalStore", {
  state: () => ({
    locales: [],
    currentLocale: undefined,
    defaultLocale: undefined,
    isMobile: false,
    settingsConst: null,
  }),

  actions: {
    parseUserAgent() {
      if (import.meta.server) return;

      const ua = navigator.userAgent.toLowerCase();
      const uaData = navigator.userAgentData;

      if (uaData && typeof uaData.mobile !== "undefined") {
        this.isMobile = uaData.mobile;
        return;
      }

      this.isMobile =
        /android|iphone|ipod|blackberry|iemobile|opera mini/i.test(ua);
    },

    async getLocales() {
      // const { getLocales } = useCoreGlobalApi();
      // const data = await getLocales();
      // this.locales = data;
      this.locales = LOCALES;
      this.defaultLocale = LOCALES.find((locale) => locale.isDefault);
    },

    setCurrentLocale() {
      const cookieLanguage = useCookie("user-language");

      if (cookieLanguage.value) {
        const cookieLanguageData = this.locales.find(
          (locale) => locale.code === cookieLanguage.value
        );
        this.currentLocale = cookieLanguageData ?? this.defaultLocale;
      } else {
        this.currentLocale = this.defaultLocale;
      }
    },

    async getSettingsConst() {
      const { data } = await useApiInstance("/settings/const");
      this.settingsConst = data;
    },
  },
});
